// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP
var _ = require('lodash');
import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import { browserHistory as history } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';
import { loadSites } from '../../actions/actions';
// import { getValuesFromParseClass } from '../../actions/Api';
import Article from 'grommet/components/Article';
import Section from 'grommet/components/Section';
import Title from 'grommet/components/Title';
import Layer from 'grommet/components/Layer';
import Header from 'grommet/components/Header';
import Box from 'grommet/components/Box';
import Carousel from 'grommet/components/Carousel';
import Button from 'grommet/components/Button';
import CaretBack from 'grommet/components/icons/base/CaretBack';
import CaretNext from 'grommet/components/icons/base/CaretNext';
import GoogleMapReact from 'google-map-react';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import constants from '../../Constants';

import NavControl from '../NavControl';
import EditTwig from './EditTwig';


import { navEnable } from '../../actions/nav';
import { loadTwigs, updateSelectedTwig, updateTwigApi } from '../../actions/locationView';

var siteName = '';
var mapComponent;
var disableAll = false;
var twigNavigation = false;
window.mapInstance = '';
class SiteView extends Component {

  constructor(props) {
    super(props);

    this.mapLoaded = this.mapLoaded.bind(this);
    this.loadNext = this.loadNext.bind(this);
    this.loadPrev = this.loadPrev.bind(this);
    this.editTwig = this.editTwig.bind(this);
    this.getOptionsFromApi = this.getOptionsFromApi.bind(this);
    this.renderTwigDetails = this.renderTwigDetails.bind(this);
    this.closeEditPop = this.closeEditPop.bind(this);
    this.saveTwig = this.saveTwig.bind(this);
    this.loadPrevRecomnd = this.loadPrevRecomnd.bind(this);
    this.loadNextRecomnd = this.loadNextRecomnd.bind(this);
    this.gotToLocation = this.gotToLocation.bind(this);
    this.getLastUpdateValue = this.getLastUpdateValue.bind(this);
    this.gotoAlerts = this.gotoAlerts.bind(this);
    this.getCenter = this.getCenter.bind(this);
    this.updateTwigLocation = this.updateTwigLocation.bind(this);
    this.mapClick = this.mapClick.bind(this);
    this.markerClick = this.markerClick.bind(this);
    this.onChange = this.onChange.bind(this);
    this.placesHandleSelect = this.placesHandleSelect.bind(this);
    this.state = {
      center: '',
      selectedTwig: (this.props.selectedTwig && this.props.selectedTwig.details && this.props.selectedTwig.details.data) ? this.props.selectedTwig : { details: { data: {} } },
      showEditPopup: false,
      recommendation: (this.props.selectedTwig && this.props.selectedTwig.recommendations.length > 0) ? this.props.selectedTwig.recommendations[0] : null,
      recommendationIndex: 0,
      showMarker: true,
      showContextMenu: false,
      contextMenTopPos: 0,
      contextMenuLeftPos: 0,
      address: '',

    }


  }
  componentWillMount() {
    this.props.dispatch(navEnable(true));
    disableAll = false;
    let _selectedTwigIndex = 0;
    // debugger
    // this.getCenter(this.props.selectedTwig);
    if(this.props.selectedTwigIndex){
      _selectedTwigIndex = Number(this.props.selectedTwigIndex);
    }
    if (this.props.location.state && this.props.location.state.name) {
      siteName = decodeURIComponent(this.props.location.state.name);
      this.setState({
        center: { lat: this.props.location.state.location.latitude, lng: this.props.location.state.location.longitude }
      });
      this.props.dispatch(loadTwigs(false, siteName, _selectedTwigIndex));

    } else {
      this.props.dispatch(loadTwigs(false, '', _selectedTwigIndex));
    }




    // if (siteName.length > 0) {

    // } else { }

    // this.props.dispatch(navEnable(true));
    // disableAll = false;
    // // debugger
    // if (this.props.location.state && this.props.location.state.name) {
    //   siteName = decodeURIComponent(this.props.location.state.name);
    //   this.setState({
    //     center: { lat: this.props.location.state.location.latitude, lng: this.props.location.state.location.longitude }
    //   });
    // } else {
    //   if (this.props.sites.length > 0) {
    //     siteName = this.props.sites[0].name;
    //     if (this.props.sites[0].location && this.props.sites[0].location.latitude && this.props.sites[0].location.longitude) {
    //       this.setState({
    //         center: { lat: this.props.sites[0].location.latitude, lng: this.props.sites[0].location.longitude }
    //       })
    //     } else {
    //       this.getCenter();
    //     }

    //   } else {
    //     this.getCenter();
    //   }
    // }
    // if (siteName.length > 0) {
    //   this.props.dispatch(loadTwigs(false, siteName, 0));
    // }
  }


  componentDidMount() {
    // this.promptLocationSettingsStatus()
  }

  componentWillReceiveProps(nextProps) {

    this.setState({
      recommendation: (nextProps.selectedTwig && nextProps.selectedTwig.recommendations.length > 0) ? nextProps.selectedTwig.recommendations[0] : null,
      recommendationIndex: 0
    }, () => {
      if (twigNavigation == false) {
        // this.getCenter(nextProps.selectedTwig);
      }
    })

    if (twigNavigation == false) {
      this.setMapBoundary(nextProps);
    }


  }

  componentDidUpdate() {
    // this.setMapBoundary(this.props);
  }

  componentWillUnmount() {
    siteName = '';
    mapComponent = '';
    twigNavigation = '';
  }

  promptLocationSettingsStatus () {
    if(navigator.geolocation){
       navigator.geolocation.getCurrentPosition(function (position){

       },function (error) {
          alert("Your browser has disabled location tracking. Please enable location tracking of your browser to make the application to work properly")
       });
    }

  }
  getCenter(selectedTwig) {

    if (this.props.location.state && this.props.location.state.name) {

      this.setState({
        center: { lat: this.props.location.state.location.latitude, lng: this.props.location.state.location.longitude }
      })

    } else if (selectedTwig.location) {
      this.setState({
        center: {
          lat: selectedTwig.location.latitude,
          lng: selectedTwig.location.longitude,
        },
        showMarker: true
      })

    } else if (this.props.userProfile && this.props.userProfile.siteLocation) {
      this.setState({
        center: {
          lat: this.props.userProfile.siteLocation.latitude, lng: this.props.userProfile.siteLocation.longitude
        }
      });
    }
    else if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        let postionObj = {
          lat: position.coords.latitude, lng: position.coords.longitude
        }
        this.setState({
          center: postionObj,
          showMarker: false
        });
      });

    } else {
      this.setState({
        center: null
      });
    }

  }

  setMapBoundary(props) {

    if (props.twigsList && props.twigsList.length > 0) {
      const bounds = new google.maps.LatLngBounds();
      var twigLocationSet = false;
      props.twigsList
        .filter(item => item != undefined && item.location !== undefined)
        .forEach(item => {
          bounds.extend(new google.maps.LatLng(item.location.latitude, item.location.longitude));
          twigLocationSet = true;
        });
      // debugger
      if (mapComponent && twigLocationSet) {
        mapComponent.map.fitBounds(bounds);
      }
      else if (this.props.location.state && this.props.location.state.name) {
        this.setState({
          center: { lat: this.props.location.state.location.latitude, lng: this.props.location.state.location.longitude }
        });
      }
    } else {
      if (this.props.location.state && this.props.location.state.name) {
        this.setState({
          center: { lat: this.props.location.state.location.latitude, lng: this.props.location.state.location.longitude }
        });
      }
    }
  }
  mapLoaded(mapObj) {
    mapComponent = mapObj;
    window.mapInstance = mapObj;
    mapObj.map.setMapTypeId('satellite');
    mapObj.map.setTilt(1);

    this.setMapBoundary(this.props)
    mapObj.map.addListener('rightclick', (event) => {
      /*
        markerLat: event.latLng.lat(),
        markerLong: event.latLng.lng()*/
      this.setState({
        showContextMenu: true,
        contextMenTopPos: event.pixel.y,
        contextMenuLeftPos: event.pixel.x,
        twigLocationLat: event.latLng.lat(),
        twigLocationLng: event.latLng.lng()
      })
    });
  }
  updateTwigLocation() {
    let data = {
      location: {
        latitude: this.state.twigLocationLat,
        longitude: this.state.twigLocationLng,
      }
    }


    //call api
    this.setState({
      showContextMenu: false,
    }, () => {
      this.saveTwigLocation(data);
    })
  }
  loadNext() {
    twigNavigation = true;
    this.props.dispatch(updateSelectedTwig(this.props.selectedTwigIndex + 1));
  }
  loadPrev() {
    twigNavigation = true;
    this.props.dispatch(updateSelectedTwig(this.props.selectedTwigIndex - 1));
  }
  editTwig(selectedValue, index) {
    this.props.dispatch(updateSelectedTwig(index));
    this.setState({
      showEditPopup: true
    })
  }

  closeEditPop() {
    this.setState(
      { showEditPopup: false }
    )
  }
  saveTwigLocation(data) {
    this.props.dispatch(updateTwigApi(this.props.selectedTwig.twigId, data, siteName, this.props.selectedTwigIndex))
  }

  saveTwig(twigObject) {
    this.setState({
      showEditPopup: false
    }, () => {
      this.props.dispatch(updateTwigApi(this.props.selectedTwig.twigId, twigObject, siteName, this.props.selectedTwigIndex))
    })
  }

  getOptionsFromApi(parseClass) {
    getValuesFromParseClass(parseClass).then(response => {
    }).catch(error => {
    });
  }
  loadNextRecomnd() {
    if (this.state.recommendation && this.state.recommendationIndex != (this.props.selectedTwig.recommendations.length - 1)) {
      let index = this.state.recommendationIndex + 1;
      this.setState({
        recommendation: this.props.selectedTwig.recommendations[index],
        recommendationIndex: index
      })
    }
  }

  loadPrevRecomnd() {
    if (this.state.recommendation && this.state.recommendationIndex != 0) {
      let index = this.state.recommendationIndex - 1;
      this.setState({
        recommendation: this.props.selectedTwig.recommendations[index],
        recommendationIndex: index
      })
    }
  }

  gotToLocation(selectedValue, index) {
    this.props.dispatch(updateSelectedTwig(index));
    // let sitename_enc = encodeURIComponent(siteInfo.name);
    history.push({
      pathname: constants.ROUTES.LOCATIONVIEW,
      // search: '?twigId=' + this.props.selectedTwig.twigId,
      state: {
        selectedTwigIndex: index,
        twigId: selectedValue.twigId,
        // twigsList: this.props.twigsList,
        // showChart: this.props.showChart
      }
    })
  }

  gotoAlerts(selectedValue, index) {
    this.props.dispatch(updateSelectedTwig(index));
    history.push({
      pathname: constants.ROUTES.ALERTS,
      state: {
        selectedTwig: selectedValue,
      }
    })
  }
  mapClick(e) {
    this.setState({
      showContextMenu: false,
      contextMenTopPos: 0,
      contextMenuLeftPos: 0
    })
  }

  getLastUpdateValue(value) {
    let today = new Date(new Date().toISOString());
    let updatedAt = new Date(value);

    let lastUpdatedDate = Math.floor((today.getTime() - updatedAt.getTime()) / 1000);

    let label = 'secs';
    if (lastUpdatedDate >= 31556926) {
      lastUpdatedDate = Math.floor(lastUpdatedDate / 31556926);
      label = lastUpdatedDate <= 1 ? 'year' : 'years';
    }
    if (lastUpdatedDate >= 2629744) {
      lastUpdatedDate = Math.floor(lastUpdatedDate / 2629744);
      label = lastUpdatedDate <= 1 ? 'month' : 'months';
    }
    if (lastUpdatedDate >= 86400) {
      lastUpdatedDate = Math.floor(lastUpdatedDate / 86400);
      label = lastUpdatedDate <= 1 ? 'day' : 'days';
    }
    if (lastUpdatedDate >= 3600) {
      lastUpdatedDate = Math.floor(lastUpdatedDate / 3600);
      label = lastUpdatedDate <= 1 ? 'hr' : 'hrs';
    }
    if (lastUpdatedDate >= 60) {
      lastUpdatedDate = Math.floor(lastUpdatedDate / 60);
      label = lastUpdatedDate <= 1 ? 'min' : 'mins';
    }

    // return lastUpdatedDate + ' ' + label;
    moment.locale('en', {
      relativeTime: {
        future: 'in %s',
        past: '%s ago',
        s:  'few secs',
        ss: '%s secs',
        m:  'a min',
        mm: '%d mins',
        h:  'an hr',
        hh: '%d hrs',
        d:  'a day',
        dd: '%d days',
        M:  'a month',
        MM: '%d months',
        y:  'a year',
        yy: '%d years'
      }
    });
    return moment(value).fromNow(true);
  }

  markerClick(indexOfTwig, event) {
      // console.log(':::', indexOfTwig)
    twigNavigation = true;
    this.props.dispatch(updateSelectedTwig(indexOfTwig));
  }
  renderFirstContainer(selectedValue, index) {
    if (selectedValue) {
      const titleValue = (selectedValue.name ? selectedValue.name.toUpperCase()+ ' AT ' : '- AT ')  + (selectedValue.locationName ? selectedValue.locationName.toUpperCase():'-');
      return [<Title title={titleValue} key='1'>
        { (selectedValue.name ? selectedValue.name.toUpperCase()+ ' AT ' : '- AT ')  + (selectedValue.locationName ? selectedValue.locationName.toUpperCase():'-')}
      </Title>,
      <div key='2' className="recommendation">
        <div className="btn-panel">
          <button onClick={() => {this.gotoAlerts(selectedValue, index)}}>Alerts</button>
          <button onClick={() => {this.editTwig(selectedValue, index)}}>Edit</button>
        </div>
      </div>,
      <div key='3' className="info-container">
        <div className="box">
          <div className="value">{selectedValue.recommendations.length}</div>
          <div className="label">Requests</div>
        </div>
        <div className="box">
          <div className="value left-pad">{this.getLastUpdateValue(selectedValue.updatedAt)}</div>
          <div className="label">Last Updated</div>
        </div>
        <div className="box">
          <div className="value">{selectedValue.settings.deepSensorCount.value}</div>
          <div className="label">Sensors</div>
        </div>
      </div>]
    } else {
      disableAll = true;
      return <h4>No data</h4>
    }

  }
  renderTwigDetails(selectedValue, indexValue) {
    let itemArr = [];
    try {
    itemArr.push(<div></div>)
    if (selectedValue && selectedValue.details && selectedValue.details.data) {
      let allObjects = []
      for (let each in selectedValue.details.data) {
        allObjects.push(selectedValue.details.data[each]);
      }
      const filterObjects = allObjects.sort((a, b) => a.sort_order - b.sort_order).filter(each => (each.sort_order !== 1 && each.sort_order !== 6));

      const sensorNames = ['','',''];
      if (selectedValue.settings.sensorName && selectedValue.settings.sensorName.value) {
        (selectedValue.settings.sensorName.value || []).map((eachSensor,sensorIndex) => {
           sensorNames[sensorIndex] = Object.values(eachSensor)[0];    
        });
      }

      itemArr[0] = [
        <div className="item" onClick={() => {this.gotToLocation(selectedValue, indexValue)}}>
          <div className="halfwidth label"></div>
          <div className="halfwidth inlineblock value-container">
            <div className="values">{sensorNames[0] !== '' ? sensorNames[0] : '-'}</div>
            <div className="values">{sensorNames[1] !== '' ? sensorNames[1] : '-'}</div>
            <div className="values">{sensorNames[2] !== '' ? sensorNames[2] : '-'}</div>
          </div>
        </div>
      ]


      filterObjects.map((item, index) => {
        let arr = ['', '', ''];
        let arrkey = ['','',''];
        if (item.multivalue && !_.isEmpty(item.multivalue)) {
          Object.keys(item.multivalue).map((subkey, subindex) => {
            arr[subindex] = item.multivalue[subkey]
            arrkey[subindex] = subkey.split(" ")[0];
          })
        } else if (item.value || item.value == 0) {
          arr[0] = item.value;
        }

        itemArr.push(
          <div className="item" key={index} onClick={() => {this.gotToLocation(selectedValue, indexValue)}}>
            <div className="halfwidth label">{item.label + ' (' + item.Unit + ')'}</div>
            <div className="halfwidth inlineblock value-container">
              <div className="values">{arr[0] !== '' ? arr[0].toFixed(1) : '-'}</div>
              <div className="values">{arr[1] !== '' ? arr[1].toFixed(1) : '-'}</div>
              <div className="values">{arr[2] !== '' ? arr[2].toFixed(1) : '-'}</div>
            </div>
          </div>
        )
      })
    }
  } catch(e) {
    console.error(e);
  }
    return itemArr;
  }

  onContextMenu(event){
    // console.log('on context menu')
    event.stopPropagation();
    event.preventDefault();
    return false;
  }
  onChange(address) {
    this.setState({
      address: address
    })
  }
  placesHandleSelect(address) {
    this.setState({
      address: address
    });
    geocodeByAddress(address)
      .then((results) => getLatLng(results[0]))
      .then(({ lat, lng }) => {
        // console.log('Success Yay', { lat, lng })
        this.setState({
          center: {
            lat: lat, lng: lng
          },
          zoom:15
        })
      })
      .catch((error) => {
        // console.log('Error:', error)
      })
  }
  render() {
    const { twigsList } = this.props;
    let renderMap = null;
    let contextMenuStyle = {
      display: this.state.showContextMenu ? 'block' : 'none',
      top: this.state.contextMenTopPos,
      left: this.state.contextMenuLeftPos
    }
    /*options={{ mapTypeControl: true }}*/
    const inputProps = {
      type: "text",
      placeholder: "🔍 Enter address",
      value: this.state.address,
      onChange: this.onChange,
    }
    const AutocompleteItem = ({ suggestion }) => (<div><i className="fa fa-map-marker" />{suggestion}</div>)
    if (this.state.center) {
      // let marker = this.state.showMarker ? <MarkerComponent lat={this.state.center.lat}
      //   lng={this.state.center.lng} twigName={this.props.selectedTwig.name} /> : null;

      let marker = this.props.twigsList.map((item, index) => {
        if (item && item.location) {
          return <MarkerComponent key={index} lat={item.location.latitude}
            lng={item.location.longitude} selectedTwigIndex={this.props.selectedTwigIndex} indexOfTwig={index} markerClick={this.markerClick} twigInfo={item} />
        } else {
          return null;
        }

      });

      renderMap = [<span style={contextMenuStyle} className='context-menu-style'>
        <button onClick={this.updateTwigLocation}>Update Stem Location</button>
      </span>, < GoogleMapReact
        defaultCenter={this.state.center}
        center={this.state.center}
        onClick={this.mapClick}
        defaultZoom={19}
        zoom={this.state.zoom}
        options={
          {
            rotateControl: true
          }
        }
        onGoogleApiLoaded={this.mapLoaded}
        yesIWantToUseGoogleMapApiInternals
        ref="googleMapSiteView"
      >
        <CenterMarkerComponent lat={this.state.center.lat}
                               lng={this.state.center.lng}  />

        {marker}

      </GoogleMapReact >]
    }

    return (
      <Article className='maxheight site-view' style={{overflowY: 'auto'}}>
        {(twigsList || []).map((each, index) => (
        <Section pad='none'
          align='start'
          className="site-control-container"
          direction='row'
          flex={false}
          style={{borderBottom: '1px solid white'}}
        >
          {/*<div className="halfheight site-control-container">*/}
          {/*<Button label=''
            icon={<CaretBackIcon />}
            onClick={this.goBack}
            plain={true} />*/}

          <div className="container1">
            {this.renderFirstContainer(each,index)}
          </div>
          <div className={"container2 " + (this.props.twigsList.length > 0 ? '' : 'hide')}>
            <div className='details-container'>
              {this.renderTwigDetails(each,index)}
            </div>
          </div>
          {/*</div>*/}
        </Section>
        ))}
        { this.state.showEditPopup
            ? <EditTwig show={this.state.showEditPopup} selectedTwig={this.props.selectedTwig} getOptionsFromApi={this.getOptionsFromApi} closeEditPop={this.closeEditPop} saveTwig={this.saveTwig} />
            : null
        }
      </Article>
    );
  }

}



let select = (state, props) => ({
  twigsList: state.locationView.twigsList,
  selectedTwig: state.locationView.selectedTwig,
  selectedTwigIndex: state.locationView.selectedTwigIndex,
  sites: state.dashboard.sites,
  // showChart: state.locationView.showChart
});

export default connect(select)(SiteView);


class MarkerComponent extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    let selectedStyle = {
      border: '2px solid #f3fa07'
    }
    let divStyle = {
      position : 'absolute',
      top : 0,
      'text-align' : 'left',
      width : '150px',
      'font-size' : '10px',
      'text-shadow' : '2px 2px black',
      color : 'white'
    }
    let imgMarkerStyle = this.props.selectedTwigIndex == this.props.indexOfTwig ? selectedStyle : {};
    return (
      <span className="marker-translate" >
        <img style={imgMarkerStyle} onClick={this.props.markerClick.bind(this, this.props.indexOfTwig)} src="/img/stem_marker.png" title={this.props.twigInfo.name} alt={this.props.twigInfo.name} />
        <div style={divStyle}>{this.props.twigInfo.name}</div>
      </span>
    );
  }
}


class CenterMarkerComponent extends Component {
  constructor(props) {
    super(props)
  }
  render() {

    return (
      <span className="marker-translate" ><img src="/img/center_marker.png"  /></span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/site/SiteView.js